export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";